import { Link } from 'react-router-dom';
import { cn } from '@/utils/cn';
import { useSiteSettings } from '@/services/settings.service';

export function Logo({ className }: { className?: string }) {
  // Falls back to the default mark below whenever no logo has been
  // uploaded yet (or the settings request hasn't resolved/failed).
  const { data: settings } = useSiteSettings();

  return (
    <Link to="/" className={cn('flex items-center gap-2.5', className)} aria-label="VEGAAHI home">
      {settings?.logoUrl ? (
        <img src={settings.logoUrl} alt="VEGAAHI" className="h-8 w-8 rounded-lg object-contain" />
      ) : (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <rect width="32" height="32" rx="8" className="fill-primary" />
          <path
            d="M8 9L16 23L24 9"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <span className="font-display text-lg font-bold tracking-tight">
        VEGA<span className="text-primary">AHI</span>
      </span>
    </Link>
  );
}
